import React, { useState, useMemo } from "react";
import { GLOSSARY, GLOSSARY_CATS } from "@/data/glossary";
import { Search } from "lucide-react";

export default function Glossary() {
  const [query, setQuery] = useState("");
  const [cat, setCat] = useState("All");

  const filtered = useMemo(() => {
    const q = query.toLowerCase().trim();
    return GLOSSARY.filter((g) => {
      const matchCat = cat === "All" || g.cat === cat;
      const matchQ = !q || g.term.toLowerCase().includes(q) || g.def.toLowerCase().includes(q);
      return matchCat && matchQ;
    }).sort((a, b) => a.term.localeCompare(b.term));
  }, [query, cat]);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-display text-3xl sm:text-4xl font-black tracking-tight">Trading Dictionary</h1>
        <p className="text-slate-400 mt-1">Search {GLOSSARY.length} essential trading terms explained simply.</p>
      </div>

      <div className="relative">
        <Search className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
        <input data-testid="glossary-search" value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Search terms…"
          className="w-full bg-[#0F172A] border border-slate-700 rounded-xl pl-10 pr-4 py-3 text-sm focus:border-blue-500 focus:outline-none" />
      </div>

      <div className="flex flex-wrap gap-2">
        {GLOSSARY_CATS.map((c) => (
          <button key={c} data-testid={`glossary-cat-${c.toLowerCase().replace(/\s+/g, "-")}`} onClick={() => setCat(c)}
            className={`px-3.5 py-1.5 rounded-lg text-sm font-medium transition-colors ${cat === c ? "bg-blue-600 text-white" : "bg-slate-800/60 text-slate-400 hover:text-slate-100"}`}>
            {c}
          </button>
        ))}
      </div>

      <div className="grid sm:grid-cols-2 gap-3">
        {filtered.map((g) => (
          <div key={g.term} data-testid={`glossary-term-${g.term.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="bg-[#0F172A] border border-slate-800 rounded-xl p-4">
            <div className="flex items-center justify-between mb-1.5">
              <h3 className="font-display font-semibold text-blue-200">{g.term}</h3>
              <span className="text-[10px] font-mono uppercase tracking-wider text-slate-500 bg-slate-800/60 rounded px-2 py-0.5">{g.cat}</span>
            </div>
            <p className="text-sm text-slate-400 leading-relaxed">{g.def}</p>
          </div>
        ))}
        {filtered.length === 0 && <div className="text-slate-500 col-span-2 text-center py-8">No terms match your search.</div>}
      </div>
    </div>
  );
}
